import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShowBul = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 10,
	viewBox: "0 0 21 10",
	...props,
	children: /* @__PURE__ */ _jsxs("text", {
		fill: "#4A5666",
		fillRule: "evenodd",
		fontFamily: "Lato-Regular, Lato",
		fontSize: 12,
		letterSpacing: -.5,
		transform: "translate(-1 -3)",
		children: [/* @__PURE__ */ _jsx("tspan", {
			x: 0,
			y: 12,
			children: "BU"
		}), /* @__PURE__ */ _jsx("tspan", {
			x: 15.524,
			y: 12,
			children: "L"
		})]
	})
});
export default SvgShowBul;
